import React, { useEffect } from "react";
import { MenuItem, Select, Grid } from "@mui/material";
import axios from "../../../Uri";
import BuildingsLayout from "./buildingsLayout/buildingsLayout";
import BedSummaryChart from "./buildingspieCharts/bedSummaryChart";
import SummaryTable from "./buildingsSummaryTable/SummaryTable";
import EmailBtn from "./EmailBtn/EmailBtn";
import { makeStyles } from "@mui/styles";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ColorFilters from "./colorFilters/ColorFilters";
import MDBox from "components/MDBox";
import OccupancyFilters from "./occupancyFilters/OccupancyFilters";
function MgrBuildingDropdown(props) {
  const useStyles = makeStyles({
    root: {
      height: 35,
    },
    size: {
      width: 40,
      height: 30,
    },
  });
  const classes = useStyles();
  const [selected, setSelected] = React.useState("");
  const [building, setBuilding] = React.useState([]);
  const [showPaymentRemainder, setShowPaymentRemainder] = React.useState(false);
  function handleChange(event) {
    setSelected(event.target.outerText);
    setShowPaymentRemainder(true);
  }
  let userData = JSON.parse(sessionStorage.getItem("userdata"));
  let buildingsId = userData.data.buildingId;

  useEffect(() => {
    axios.get(`bed/getBuildingsById/${buildingsId}`).then((res) => {
      setBuilding(res.data);
    });
  }, []);
  return (
    <>
      <Grid container>
        <Grid item lg={6} md={6} xs={12}>
          <label value="Select Building: ">Select Building: </label>
          <Select
            sx={{ minHeight: 44 }}
            style={{ width: "50%", height: "10%" }}
            defaultValue={building.buildingName}
            name="building"
            IconComponent={() => <ArrowDropDownIcon className={classes.size} />}
          >
            <MenuItem value={building.buildingName} onClick={handleChange}>
              {" "}
              {building.buildingName}{" "}
            </MenuItem>
          </Select>
        </Grid>
        <Grid item xs={6}>
          {showPaymentRemainder ? <EmailBtn buildingId={buildingsId} /> : <></>}
        </Grid>
      </Grid>
      {building.buildingName === selected ? (
        <Grid>
          <Grid
            container
            direction="row"
            justifyContent="left"
            alignItems="left"
          >
            <Grid item xs={6}>
              <BedSummaryChart buildingId={buildingsId} />
            </Grid>
            <Grid item xs={6}>
              <SummaryTable buildingId={buildingsId} />
            </Grid>
          </Grid>
          <MDBox padding="30px">
            <br />
            <ColorFilters buildingId={buildingsId} />
          </MDBox>
          <br></br>
          <BuildingsLayout buildingId={buildingsId} />
        </Grid>
      ) : (
        <></>
      )}
    </>
  );
}
export default MgrBuildingDropdown;
